<template lang="pug">
  v-layout(row wrap)
    v-form.mr-2(
      ref="form"
      v-model="valid"
    )
      .mt-4
        p.title-step.ml-3
          strong What is a brand?
          |  A brand is the company that informs the recipient who sent the message and the carrier who is sending the messages.
          | Please provide complete and up-to-date information about your company.
      v-flex(v-show="!isRetryState" xs12 mt-1 pb-0)
        v-flex(xs6)
          h3 Text volume
          v-select(
            v-model="brandForm.textVolume"
            :disabled="lockTextVol"
            :rules="[rules.required]"
            :items="this.textVolumeType"
            item-text="text"
            item-value="value"
            required
          )
        v-flex.pa-0(xs6)
      v-flex.fee-text(v-if="isStandardSelected" v-show="!isRetryState" xs12 my-0)
        p.ml-4.mb-2 Unlocking texting requires a registration fee by the US mobile carriers - 
          a(href="https://lonewolf.my.site.com/s/article/LD-FAQ-Texting-brand-registration-changes-June-2023-LionDesk" target="_blank") click here to learn more:
        ul.fee-list.ml-4
          li One-time fee: $109 for Brand and Campaign registration
          li Monthly fee: $12/mo for your campaign use case
        p.ml-4.mt-2 We will collect this fee on your behalf using the credit card you have on file.
      v-flex.fee-text(v-else v-show="!isRetryState" xs12 my-0)
        p.ml-4.mb-2 Unlocking texting requires a registration fee by the US mobile carriers - 
          a(href="https://lonewolf.my.site.com/s/article/LD-FAQ-Texting-brand-registration-changes-June-2023-LionDesk" target="_blank") click here to learn more:
        ul.fee-list.ml-4
          li One-time fee: $19 for Brand and Campaign registration
          li Monthly fee: $2/mo for your campaign use case
        p.ml-4.mt-2 We will collect this fee on your behalf using the credit card you have on file.
      v-flex(xs12 v-if="hasRegistrationError" row)
        custom-error-registration(
          :errors="registrationErrors"
          :registrationStatus10dlc="registrationStatus10dlc"
          :registrationCampaignRetries="registrationCampaignRetries"
        )
      v-flex.ml-2.mt-2(xs12)
        v-layout(wrap)
          v-flex(xs6)
            h3 Business registration ID type
            v-select(
              label="Select your business Registration ID type*"
              v-model="brandForm.businessRegistration"
              :rules="[rules.required]"
              :items="this.businessRegistrationIDType"
              item-text="text"
              item-value="value"
              required
            )
          v-flex(xs6)
            h3 Business registration number/tax ID
            v-tooltip(bottom)
              template(slot="activator")
                v-text-field(
                  :label="labelFieldBusinessNumberTaxID"
                  v-model="brandForm.businessRegistrationEIN"
                  :rules="[rules.numberEIN]"
                  browser-autocomplete="disable"
                  :messages="msgFieldBusinessNumberTaxID"
                  required
                  @change="formatBusinessNumber"
                )
              span To maximize your messages deliverability, <br> please put in exactly the details as <br> registered with the IRS.
      v-flex.ml-2(xs12)
        v-layout(wrap)
          v-flex(xs6)
            h3 Business general information
            v-text-field(
              label="Business Name*",
              v-model="brandForm.businessName"
              :rules="[rules.required]"
              :messages="msgFieldBusinessName"
              required
            )
          v-flex(xs6)
            h3 Business type
            v-select(
              label="Select your business type*"
              v-model="brandForm.businessType"
              :rules="[rules.required]"
              :items="this.businessType"
              item-text="text"
            )
      v-flex.ml-2(xs12)
        v-layout(wrap)
          v-flex(xs6)
            h3 Business region of operations (check all that apply)
            v-select(
              label="Select your business regions of operation*"
              v-model="brandForm.businessRegion"
              :rules="[rules.required]"
              :items="this.businessRegionOperations"
              item-text="text"
              item-value="value"
              multiple
              required
            )
          v-flex(xs6)
            h3 Business industry
            v-select(
              label="Select your business industry*"
              v-model="brandForm.businessIndustry"
              :rules="[rules.required]"
              :items="this.businessIndustry"
              item-text="text"
              item-value="value"
              required
            )
      v-flex.ml-2(xs12)
        v-layout(wrap)
          v-flex(xs6)
            h3 Company type
            v-select(
              label="Select your company type*"
              v-model="brandForm.companyType"
              :rules="[rules.required]"
              :items="this.companyType"
              item-text="text"
              item-value="value"
              required
            )
          v-flex(xs6)
            h3 Company website
            v-text-field(
              label="Website*"
              v-model="brandForm.website"
              :rules="[rules.website]"
              browser-autocomplete="disable"
              @change="formatWebsite"
              required
            )
      v-flex.ml-2(xs12 v-if="businessTypePublic")
        v-layout(wrap)
          v-flex(xs6)
            h3 Company stock ticker symbol
            v-text-field(
              label="Enter stock ticker symbol*"
              v-model="brandForm.stockSymbol"
              :rules="[rules.stockSymbol, rules.required]"
              browser-autocomplete="disable"
              required
            )
          v-flex(xs6)
            h3 Company stock exchange
            v-select(
              label="Select your stock exchange*"
              v-model="brandForm.stockExchangeType"
              :rules="[rules.required]"
              :items="this.stockExchangeType"
              item-text="text"
            )
      v-flex.ml-2(xs12)
        v-layout.row-title(wrap)
          v-flex(xs12)
            h3 Business physical address
        v-layout(wrap)
          v-flex(xs6)
            v-layout(row wrap)
              v-flex(xs4)
                v-select(
                  label="Country*"
                  v-model="brandForm.country"
                  :rules="[rules.required]"
                  browser-autocomplete="disable"
                  :items="this.countries"
                  item-text="text"
                  item-value="value"
                  @change="onCountryChange"
                  required
                )
              v-flex(xs4)
                v-tooltip(bottom max-width="250px")
                  template(slot="activator")
                    v-text-field(
                      label="Street*"
                      v-model="brandForm.street"
                      :rules="[rules.required]"
                      browser-autocomplete="disable"
                      error-messages=""
                      required
                    )
                  span {{ addressPOBoxMessage }}
              v-flex(xs4)
                v-text-field(
                  label="City*"
                  v-model="brandForm.city"
                  :rules="[rules.required]"
                  browser-autocomplete="disable"
                  required
                )
          v-flex(xs6)
            v-layout( wrap)
              v-flex(xs4)
                v-autocomplete(
                  label="State/Province/Region*"
                  v-model="brandForm.state"
                  :rules="[rules.required]"
                  browser-autocomplete="disable"
                  :items="states"
                  item-text="text"
                  item-value="value"
                  required
                )
              v-flex(xs4)
                v-text-field(
                  v-if="brandForm.country === 'US'"
                  label="Zip Code*"
                  v-model="brandForm.zipCode"
                  :rules="[rules.required, rules.zipCode]"
                  browser-autocomplete="disable"
                  mask="#####"
                  required
                )
                v-text-field(
                  v-else
                  label="Zip Code*"
                  v-model="brandForm.zipCode"
                  :rules="[rules.required]"
                  browser-autocomplete="disable"
                  required
                )





      v-flex.ml-2(xs12)
        v-layout.row-title(wrap)
          v-flex(xs12)
            h3 Authorized representative information
            p.subtitle-section.theme--light.v-messages More details about who is the Authorized representative
        v-layout(wrap)
          v-flex(xs6)
            v-layout(row wrap)
              v-flex(xs4)
                v-text-field(
                  label="First Name*"
                  v-model="brandForm.firstName"
                  :rules="[rules.required]"
                  browser-autocomplete="disable"
                  required
                )
              v-flex(xs4)
                v-text-field(
                  label="Last Name*"
                  v-model="brandForm.lastName"
                  :rules="[rules.required]"
                  browser-autocomplete="disable"
                  required
                )
              v-flex(xs4)
                v-text-field(
                  label="Email*"
                  v-model="brandForm.email"
                  :rules="[rules.email]"
                  browser-autocomplete="disable"
                  type="email"
                  required
                )
          v-flex(xs6)
            v-layout( wrap)
              v-flex(xs4)
                v-text-field(
                  label="Phone*"
                  v-model="brandForm.phone"
                  :rules="[rules.phone]"
                  browser-autocomplete="disable"
                  required
                  @change="formatPhoneNumber"
                )
              v-flex(xs4)
                v-text-field(
                  label="Business title*"
                  v-model="brandForm.businessTitle"
                  :rules="[rules.required]"
                  browser-autocomplete="disable"
                  required
                )
              v-flex(xs4)
                v-select(
                  label="Job Position*"
                  v-model="brandForm.jobPosition"
                  :rules="[rules.required]"
                  :items="this.jobPositions"
                  item-text="text"
                  item-value="value"
                  required
                )
      v-flex.actions(xs12)
        v-btn(
          color="primary"
          data-cy="next-campaign-step"
          :disabled="!valid"
          @click="goNextStep"
        ) Continue to Campaign
</template>
<script>
import CustomErrorRegistration from '@/Core/components/CustomErrorRegistration';
import {
  EMAIL_REGEX,
  PHONE_WITHOUT_COUNTRY_REGEX,
  WEBSITE_REGEX,
  WEBSITE_PROTOCOL_REGEX,
  NUMBER_EIN_REGEX,
  STOCK_SYMBOL_REGEX,
  US_ZIP_CODE_REGEX,
} from "@/Core/config/regex";

import {
  STATES_CA,
  STATES_US
} from "../config/states";

import {
  BUSINESS_INDUSTRY,
  BUSINESS_REGIONS_OPERATIONS,
  BUSINESS_REGISTRATION_ID_TYPE,
  BUSINESS_TYPE,
  COMPANY_TYPE,
  COUNTRIES,
  JOB_POSITIONS,
  STOCK_EXCHANGE_TYPE,
  ADDRESS_PO_BOX_MESSAGE,
  EIN,
  BIN,
} from "../config";

import {
  BRAND_TEXT_VOLUME_OPTIONS,
  STANDARD_BRAND,
  LOW_STANDARD_BRAND,
} from 'lion-vue-src/config/brand';

import { STANDARD_RETRY_STATES } from '../config';

import { mapMutations, mapState, mapGetters } from "vuex";

export default {
  name: 'FormBrand',
  props: {
    standard: {
      type: Boolean,
      default: false,
    },
    lockTextVol: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CustomErrorRegistration
  },
  data() {
    return {
      valid: true,
      brandForm: {
        businessName: null,
        street: null,
        zipCode: null,
        city: null,
        state: null,
        country: null,
        businessType: null,
        businessRegistration: null,
        businessRegistrationEIN: null,
        businessIndustry: null,
        website: null,
        businessRegion: null,
        companyType: null,
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        businessTitle: null,
        jobPosition: null,
        stockExchangeType: null,
        stockSymbol: null,
        textVolume: null
      },
      einNumber: null,
      rules: {
        required: value => {
          return !!value || 'This field is required'
        },
        email: value => {
          return EMAIL_REGEX.test(value) || 'Invalid Email address'
        },
        phone: value => {
          return PHONE_WITHOUT_COUNTRY_REGEX.test(value) || 'Invalid phone number';
        },
        website: value => {
          return WEBSITE_REGEX.test(value) || 'Invalid Website'
        },
        numberEIN: value => {
          return NUMBER_EIN_REGEX.test(value) || 'Invalid Business registration number/tax EIN'
        },
        stockSymbol: value => {
          return STOCK_SYMBOL_REGEX.test(value) || 'Invalid stock symbol'
        },
        zipCode: value => {
          return US_ZIP_CODE_REGEX.test(value) || 'Invalid zip code';
        },
      },
      countries: COUNTRIES,
      businessType: BUSINESS_TYPE,
      businessRegistrationIDType: BUSINESS_REGISTRATION_ID_TYPE,
      businessIndustry: BUSINESS_INDUSTRY,
      businessRegionOperations: BUSINESS_REGIONS_OPERATIONS,
      jobPositions: JOB_POSITIONS,
      companyType: COMPANY_TYPE,
      statesCA: STATES_CA,
      statesUS: STATES_US,
      stockExchangeType: STOCK_EXCHANGE_TYPE,
      addressPOBoxMessage: ADDRESS_PO_BOX_MESSAGE,
      textVolumeType: BRAND_TEXT_VOLUME_OPTIONS,
    }
  },
  watch: {
    'brandForm.textVolume': function (textVolumeValue) {
      this.setTextVolume(textVolumeValue);
    },
    'brandForm.businessRegistrationEIN': function (businessRegistrationEIN) {
      this.einNumber = businessRegistrationEIN;
    },
    a2pBrandForm(brandData) {
      this.brandForm = {
        ...this.brandForm,
        ...brandData,
      };
    },
  },
  computed: {
    ...mapState('registerCustomerA2p', {
      a2pBrandForm: 'brandForm'
    }),
    ...mapState('conversations', [
      'registrationStatus10dlc',
      'registrationStatusData10dlc',
      'registrationBrandRetries',
      'registrationType10dlc',
      'registrationCampaignRetries',
    ]),
    businessTypePublic() {
      return this.brandForm.companyType === "public";
    },
    states() {
      if (this.brandForm.country == null)
        return [];
      if (this.brandForm.country == 'US') {
        return this.statesUS;
      }
      return this.statesCA;
    },
    isStandardSelected() {
      const { textVolume } = this.brandForm;
      return textVolume === STANDARD_BRAND;
    },
    labelFieldBusinessNumberTaxID() {
      const type = this.businessRegistrationType;
      return `Enter your business registration ${type}*`;
    },
    helpLinkBusinessNumberTaxID() {
      switch (this.brandForm.businessRegistration) {
        default:
        case EIN: {
          let einLink = `https://www.hipaaspace.com/ein/ein_verification/`;
          if (this.einNumber) {
            einLink += this.einNumber;
          }
          return einLink;
        }
        case BIN:
          return 'https://ised-isde.canada.ca/cc/lgcy/fdrlCrpSrch.html';
      }
    },
    businessRegistrationType() {
      return this.brandForm.businessRegistration === BIN
        ? "BN"
        : this.brandForm.businessRegistration
          ? this.brandForm.businessRegistration
          : "EIN/BN";
    },
    msgFieldBusinessNumberTaxID() {
      const type = this.businessRegistrationType;
      return `Don't remember your business registration ${type}? <a href='${this.helpLinkBusinessNumberTaxID}' target='_blank'> Click here </a> to get it.`;
    },
    msgFieldBusinessName() {
      const helpLink = this.helpLinkBusinessNumberTaxID;
      return `<b>Important</b>: Enter business name <b>exactly</b> as it appears on your ID record, or <b>your registration may fail</b>. <a href='${helpLink}' target='_blank'> Click here </a> to get it.`;
    },
    hasRegistrationError() {
      return (
        [
          'campaign_tcr_failed',
          'campaign_twilio_failed',
          'campaign_blocked_failed',
          'brand_failed',
          'brand_tcr_failed',
          'a2p_bundle_failed',
          'customer_profile_failed',
        ].includes(this.registrationStatus10dlc) &&
        this.registrationStatusData10dlc &&
        !!this.registrationStatusData10dlc.length
      );
    },
    registrationErrors() {
      let errors = [];
      if (this.hasRegistrationError) {
        errors = errors.concat(this.registrationStatusData10dlc.map(x => x.description));
      }

      if (['brand_tcr_failed'].includes(this.registrationStatus10dlc)) {
        errors = errors.concat(this.brandTCRFailedErrors);
      }

      return errors;
    },
    brandTCRFailedErrors() {
      let errors = [];
      let attempt = ['first', 'second', 'final'];
      let times = 'up to 3';
      if (this.isStandardRegistration) {
        attempt = ['first', 'final'];
        times = '2';
      }
      if ((this.isStandardRegistration && this.registrationBrandRetries < 2) || (!this.isStandardRegistration && this.registrationBrandRetries < 3)) {
        errors = errors.concat([`<strong>This is your ${attempt[this.registrationBrandRetries]} retry attempt</strong>. You may retry ${times} times after your initial identity submission before a new identity verification fee is incurred. Please follow exact form instructions to avoid errors.`]);
      } else {
        errors = errors.concat([`<strong>This submission will restart your identity registration</strong>. US carriers will charge you a verification restart fee to continue.`])
      }
      if (this.registrationBrandRetries > 0) {
        errors = errors.concat([`Need help fixing your registration? <a href='${this.errorMailString}' target='_blank'>Contact support</a> for assistance.`]);
      }
      return errors;
    },
    errorMailString() {
      let errors = '';
      if (this.registrationStatusData10dlc) {
        errors = `${this.registrationStatusData10dlc.map(x => x.description).join('\n\n')}`;
      }
      let attempt = ['', '2nd Retry', '3rd Retry', 'Restart'];
      if (this.isStandardRegistration) {
        attempt = ['', '2nd Retry', 'Restart'];
      }
      var subject = encodeURIComponent(`Texting: Standard registration assistance - ${attempt[this.registrationBrandRetries]}`);
      var body = encodeURIComponent(`My Standard registration is returning this error after multiple attempts:\n\n${errors}`);
      return `mailto:support@liondesk.com?subject=${subject}&body=${body}`
    },
    isStandardRegistration() {
      return this.registrationType10dlc === STANDARD_BRAND;
    },
    isRetryState() {
      return STANDARD_RETRY_STATES.includes(this.registrationStatus10dlc);
    },
  },
  methods: {
    ...mapMutations('registerCustomerA2p', [
      'setBrandForm',
      'setStep',
      'setTextVolume',
    ]),
    goNextStep() {
      if (this.$refs.form.validate()) {
        this.setBrandForm({ form: this.brandForm });
        this.setStep({ step: 1 });
      }
    },
    onCountryChange() {
      const { zipCode } = this.brandForm;
      if (!zipCode || zipCode.length === 0) return;
      this.brandForm.zipCode = '';
    },
    loadDefaultTextVolume() {
      this.brandForm.textVolume = this.standard ? STANDARD_BRAND : LOW_STANDARD_BRAND;
    },
    formatPhoneNumber() {
      this.brandForm.phone = this.brandForm.phone.replace(/\D/g, "");
    },
    formatBusinessNumber() {
      this.brandForm.businessRegistrationEIN = this.brandForm.businessRegistrationEIN.replace(/\D/g, "");
    },
    formatWebsite() {
      if (!this.brandForm || !this.brandForm.website) {
        return
      }
      this.brandForm.website = this.brandForm.website.trim();
      if (WEBSITE_REGEX.test(this.brandForm.website) && !WEBSITE_PROTOCOL_REGEX.test(this.brandForm.website)) {
        this.brandForm.website = 'https://' + this.brandForm.website;
      }
    },
    validateForm() {
      return this.$refs.form.validate();
    },
  },
  mounted() {
    this.loadDefaultTextVolume();
  },
}
</script>
<style scoped>
h3 {
  font-size: 14px !important;
}

.actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.title-step {
  font-size: 16px;
  line-height: 25px;
}

.subtitle-section {
  font-size: 14px;
}

.row-title {
  margin-bottom: -16px !important;
}

.fee-text {
  background-color: #dee7f1;
  border-radius: 10px;
  font-weight: 500;
  font-size: 16px;
}

.fee-list {
  list-style-type: none;
}
</style>
